import { ProductsDto } from '@maia/shared';
import { flow } from 'es-toolkit';
import { parseQuery } from 'ufo';

type NormalizeGuids = ({
  guid,
}: {
  guid: string | Array<string>;
}) => Array<string>;
const normalizeGuids: NormalizeGuids = ({ guid: guids = [] }) =>
  Array.isArray(guids) ? guids : [guids];

export const parseProductsFromQuery = flow(parseQuery, normalizeGuids);

type ReplaceProductGuids = (
  currentGuids: Array<string>,
  products: Array<ProductsDto>,
) => Array<string>;
export const replaceProductGuids: ReplaceProductGuids = (
  currentGuids,
  products,
) => {
  return currentGuids.map((currentGuid) => {
    const product = products.find(
      (product) => product.productGuid === currentGuid,
    );
    return product?.guid;
  });
};

type IsFinalProduct = (
  currentProduct: string,
  products: Array<string> | undefined,
) => boolean;
export const isFinalProduct: IsFinalProduct = (currentProduct, products) => {
  if (!products) return true;
  return products.indexOf(currentProduct) === products.length - 1;
};

type GetNextProduct = (
  currentProduct: string,
  products: Array<string> | undefined,
) => string | undefined;
export const getNextProduct: GetNextProduct = (currentProduct, products) => {
  if (!products) return undefined;
  const currentIndex = products.indexOf(currentProduct);
  return products[currentIndex + 1];
};
